// extracted by mini-css-extract-plugin
export default {"container":"ProjectSidePanel-module__container___orQfK","tabContainer":"ProjectSidePanel-module__tabContainer___MqP9l","projectTabs":"ProjectSidePanel-module__projectTabs___RIe6P"};